var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AMap',{on:{"ready":function($event){return _vm.handleMapReady($event)},"created":function($event){return _vm.handleMapCreated($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }